import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { Alert, Button, Input, errorMessage } from '../components/ui';

export function PasswordForm({ onChanged }: { onChanged: () => Promise<void> | void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const tooShort = next.length > 0 && next.length < 12;
  const mismatch = confirm.length > 0 && confirm !== next;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/v1/me/password', { currentPassword: current, newPassword: next });
      setDone(true);
      setCurrent('');
      setNext('');
      setConfirm('');
      await onChanged();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" noValidate>
      {error && <Alert tone="error">{error}</Alert>}
      {done && <Alert tone="success">Senha alterada. Suas outras sessões foram encerradas.</Alert>}
      <Input
        label="Senha atual"
        type="password"
        autoComplete="current-password"
        value={current}
        onChange={(e) => setCurrent(e.target.value)}
      />
      <Input
        label="Nova senha"
        type="password"
        autoComplete="new-password"
        hint="Mínimo de 12 caracteres. Uma frase longa é mais segura e fácil de lembrar."
        error={tooShort ? 'Use pelo menos 12 caracteres.' : undefined}
        value={next}
        onChange={(e) => setNext(e.target.value)}
      />
      <Input
        label="Confirmar nova senha"
        type="password"
        autoComplete="new-password"
        error={mismatch ? 'As senhas não conferem.' : undefined}
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
      />
      <Button type="submit" busy={busy} disabled={!current || next.length < 12 || next !== confirm}>
        Alterar senha
      </Button>
    </form>
  );
}
